var $ = jQuery.noConflict();
$(document).ready(function () {
  $('.enumenu_ul').responsiveMenu({
    'menuIcon_text': 'Menu',
    onMenuopen: function () {}
  });
  
  /*banner slider*/
  if($('.home-slider').length){
    $('.home-slider').owlCarousel({
      loop:true,
      items:1,    
      nav:true,
      dots: false,
      responsiveClass:true,
      responsive:{
        0:{
          nav:false
        },
        768:{
          nav:true
        }
      }    
    });
  }

  /*terms and conditions accordian*/
  /*var slide = $('.faq-tab')
  slide.find('.faq-tab-contain-text').slideUp();
  slide.click(function() {
    slide.not(this).find('.faq-tab-contain-text').slideUp();
    $(this).find('.faq-tab-contain-text').slideToggle();       
  });

  $('.faq-tab').click(function() {
    if ( $(this).hasClass('active')) {
      $(this).removeClass('active')
    }else
    {
      $('.faq-tab.active').removeClass('active');
      $(this).addClass('active')
    }
  });*/
  $(document).on("click",'.faq-tab a', function(){
  //$(".faq-tab a").click(function(){
    $(".faq-tab-contain-text").slideUp();
    $(this).siblings(".faq-tab-contain-text").stop().slideToggle();
    if($(this).hasClass("active")){
      $(this).removeClass("active");
    }
    else{
      $(".faq-tab a").removeClass("active");
      $(this).addClass("active");
    }
  });
  
  // equal height
  $(".bc-sf-filter-product-item .bc-sf-filter-product-item-title, .collectionproductdescription .short").equalHeight();
  
  //object fit banner slider image
  var userAgent, ieReg, ie;
  userAgent = window.navigator.userAgent;
  ieReg = /msie|Trident.*rv[ :]*11\./gi;
  ie = ieReg.test(userAgent);

  if(ie) {
    $(".home-slide-img").each(function () {
      var $container = $(this),
          imgUrl = $container.find("img").prop("src");
      if (imgUrl) {
        $container.css("backgroundImage", 'url(' + imgUrl + ')').addClass("custom-object-fit");
      }
    });
  }

  
});  

/*$(window).resize(function () {
  var mainHeight = $('header .site-header').outerHeight();
  var winTop = $(window).scrollTop();
  if (winTop >= mainHeight) {
    $('body').addClass('stickyHeader');
  } else {
    $('body').removeClass('stickyHeader');
  }
});

$(window).load(function () {

});

$(window).scroll(function () {
  //stickyHeader();
  var mainHeight = $('header .site-header').outerHeight();
  var winTop = $(window).scrollTop();
  if (winTop >= mainHeight) {
    $('body').addClass('stickyHeader');
  } else {
    $('body').removeClass('stickyHeader');
  }
});*/

/*function stickyHeader() {
  var bannerMain = $(".bannerMain").innerHeight();
  if ($(window).scrollTop() > bannerMain) {
    $("header").addClass("stickyHeader");
  } else {
    $("header").removeClass("stickyHeader");
  }
};*/



// equal height
;(function($){
$.fn.equalHeight = function (option) {
var $this = this
var get_height = function(){
var maxheight=0;
$this.css("height","")
$this.each(function(){
maxheight = $(this).height() > maxheight ? $(this).height() : maxheight;
})
$this.height(maxheight)
}
var init =function(){
get_height()
$(window).bind("resize",get_height)
}
$this.destroy = function(){
$this.css("height","")
$(window).unbind("resize",get_height)
}
init()
return this
} 
})(jQuery)